/* eslint-disable prettier/prettier */
import React from "react";
import Text from "@/bit/components/next13.components.text";

const Header5Title = (props) => {
  const { title, theme, textProps } = props;
  if (!theme) {
    return null;
  }
  let fontType, size, color;
  switch (theme) {
    case "areaprivada":
      size = "title04";
      color = "white";
      fontType = "font-regular";
      break;
    case "detalle":
      size = "title04";
      color = "dark-blue";
      fontType = "font-bold";
      break;

    default:
      size = "title03";
      color = "dark-blue";
      fontType = "font-bold";
  }
  return (
    <>
      <div className="header5-title">
        <div className={theme}>
          <div className="container">
            <Text
              {...textProps}
              text={title}
              fontType={fontType}
              size={size}
              color={color}
            />
          </div>
        </div>
        <style jsx>{`.header5-title {
  .areaprivada {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
    background-color: #019df4;
  }
  .default {
    .text {
      font-size: 1.25rem;
    }
  }
}

@media screen and (min-width: 768px) {
  .header5-title {
    .areaprivada {
      padding-top: 0rem;
      padding-bottom: 0rem;
      background-color: #019df4;
    }
    .default {
      .text {
        font-size: 1.75rem;
      }
    }
  }
}
`}</style>
      </div>
    </>
  );
};
export default Header5Title;
